import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import ManageVendorPopover from 'vendors/vendorAppBar/ManageVendorPopover'
import Divider from '@mui/material/Divider'
import Box from '@mui/material/Box'
import { styled } from '@mui/material'
import UserPopover from 'vendors/components/appBar/UserPopover'
import { Link } from 'react-router-dom'
import ThingerLogo from 'vendors/components/icons/ThingerLogo'

const Offset = styled('div')(({ theme }) => theme.mixins.toolbar)

export default function ButtonAppBar() {
  return (
    <>
      <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
        <Toolbar sx={{ color: 'common.white' }}>
          <Box sx={{ flexGrow: 1 }}>
            <Box sx={{ height: 44, width: 120 }}>
              <Link to="/vendors">
                <ThingerLogo />
              </Link>
            </Box>
          </Box>
          <ManageVendorPopover />
          <Box sx={{ display: 'flex' }}>
            <Divider
              sx={{ backgroundColor: 'common.white', ml: 2, mr: 3, height: '24px' }}
              orientation="vertical"
              variant="middle"
              flexItem
            />
          </Box>
          <UserPopover />
        </Toolbar>
      </AppBar>
      <Offset />
    </>
  )
}
